<template>
  <div class="chart-container">
    <div class="d-flex justify-content-end" v-if="!isKPKSubdomain">
      <category-combo-box class="mr-2" v-if="showComboBox"
      
        v-model="formData.prokuroriaId"
        :api-url="prokuroriaURL"
      />


      <authoret-combo-box  class="ms-2"
        v-model="formData.authorId"
        :api-url="authorURL"
      />
    </div>
    <BarChart :chart-data="chartData" :options="chartOptions" :height="175" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';
import CategoryComboBox from './CategoryComboBox.vue';
import AuthoretComboBox from './AuthoretComboBox.vue';
import axios from 'axios';

import {getWebPagesId} from '@/utils/webPage.js';



Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: 'BarChartComponent',
  components: {
    BarChart: Bar,
    CategoryComboBox,
    AuthoretComboBox,
  },
  data() {
    return {
      prokuroriaURL: 'Prokurorit',
     
      formData: {
      prokuroriaId: null,
      authorId: null,
    },
      chartData: {
        labels: [],
        datasets: [
          { 
           // label: 'Të pranuara',
          label: this.$t('raporti_grafikonet.tepranurar'),
            backgroundColor: '#3498DB',
            data: [],
          },
          {
            //label: 'Të zgjidhura',
              label: this.$t('raporti_grafikonet.tezgjedhur'),
            backgroundColor: '#E74C3C',
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
           text: this.$t('raporti_grafikonet.tedhenaperlendete'),
           // text: 'Të Dhëna për Lëndët',
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 250,
            ticks: {
              stepSize: 50,
            },
          },
        },
      },
      loading: false,
      isKPKSubdomain: false,
    };
  },

  created() {
    // Fetch initial chart data when the component is created
   const host = window.location.hostname;
   this.isKPKSubdomain = host === 'kpk.prokuroria-rks.org' || host === 'kpk.localhost';
   const webPageId=getWebPagesId();
   if(webPageId!==3){
    this.formData.prokuroriaId = webPageId;
   }
 
 


  },
  computed: {
  authorURL() {
    // Build the URL based on the selected prokuroriaId
    return this.formData.prokuroriaId
      ? `${this.formData.prokuroriaId}`
      : 0;
  },

  showComboBox(){
 
 return getWebPagesId()===3;

    }
  },

  watch: {
    'formData.prokuroriaId'(newVal) {
      if (newVal && this.formData.authorId) {
        this.fetchChartData();
      }
    },
    'formData.authorId'(newVal) {
      if (newVal && this.formData.prokuroriaId) {
        this.fetchChartData();
      }
    },
  },
  methods: {
    async fetchChartData() {
  this.loading = true;
  try {
    const response = await axios.post(
      'https://prokuroriaapi.cmdsoftwares.com/api/v1/dashboard/graph-chart/summary',
      {
        prokuroriaId: this.formData.prokuroriaId,
        authorId: this.formData.authorId,
        year: new Date().toISOString(), // or use a selected year if you have one
      }
    );
    const data = response.data;

    // Map API data to chart format
    this.chartData.labels = data.map(item => item.halfYear);
    this.chartData.datasets = [
      {
        //label: 'Trashëguara',
        label: this.$t('raporti_grafikonet.tetrasheguara'),


        backgroundColor: '#8e44ad',
        data: data.map(item => item.inherited),
      },
      {
        //label: 'Të pranuara',
        label: this.$t('raporti_grafikonet.tepranurar'),


        backgroundColor: '#3498DB',
        data: data.map(item => item.accepted),
      },
      {
        //label: 'Gjithsej',

        label: this.$t('raporti_grafikonet.gjithsej'),

        backgroundColor: '#f1c40f',
        data: data.map(item => item.inTotal),
      },
      {
        //label: 'Të zgjidhura',
        label: this.$t('raporti_grafikonet.tezgjedhur'),
        backgroundColor: '#E74C3C',
        data: data.map(item => item.solved),
      },
      {
        //label: 'Të pazgjidhura',
        label: this.$t('raporti_grafikonet.tepazgjidhura'),
        backgroundColor: '#2ecc71',
        data: data.map(item => item.unSolved),
      },
    ];

    this.chartOptions.plugins.title.text =this.$t('raporti_grafikonet.tedhenaperlendete'); //'Të Dhëna për Lëndët';
    this.chartData = { ...this.chartData };
  } catch (error) {
    console.error('Error fetching chart data:', error);
  } finally {
    this.loading = false;
  }
},
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  margin: 20px auto;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #EAECF0;
  height: 424px;
}
</style>